import jss from 'jss';
import warning from 'warning';

var counter = 0;
var stylesheets = new WeakMap();

function getStyleSheet(jssInstance) {
  if (stylesheets.has(jssInstance)) {
    return stylesheets.get(jssInstance);
  }

  var stylesheet = jssInstance.createStyleSheet(null, {
    meta: 'JSS Keyframes'
  });
  stylesheets.set(jssInstance, stylesheet);
  stylesheet.attach();
  return stylesheet;
}

function createKeyframes(keyframes, options) {
  if (options === void 0) {
    options = {};
  }

  counter++;
  warning(counter <= 10000, 'You might have a memory leak because the keyframes counter grew up to 10000');
  var keyframesName = process.env.NODE_ENV === 'production' ? "c" + counter : "" + (options.name ? options.name + "-" : 'animation-') + counter;
  var jssInstance = options.jss || jss;
  var stylesheet = getStyleSheet(jssInstance);
  stylesheet.addRule("@keyframes " + keyframesName, keyframes); // Makes the styles visible in the element

  stylesheet.deploy();
  return keyframesName;
}

export default createKeyframes;
